import React, { createContext, useState, useContext } from 'react';
import api from '../api/axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });
  // perms: { feature_key: { is_hidden: bool, can_read: bool, can_write: bool } }
  const [perms, setPerms] = useState(() => {
    try { return JSON.parse(localStorage.getItem('perms')) || {}; } catch { return {}; }
  });
  const [loading, setLoading] = useState(false);

  const fetchPerms = async () => {
    try {
      const res = await api.get('/api/permissions/my');
      const permMap = {};
      (res.data || []).forEach(p => { permMap[p.feature] = p; });
      setPerms(permMap);
      localStorage.setItem('perms', JSON.stringify(permMap));
    } catch {
      setPerms({});
      localStorage.removeItem('perms');
    }
  };

  const login = async (username, password) => {
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', { username, password });
      const { token, user: userData } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
      // Fetch permissions right after login so sidebar reflects them immediately
      await fetchPerms();
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Login failed' };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('perms');
    setUser(null);
    setPerms({});
  };

  // Call this after admin saves permissions for another user
  const refreshPerms = fetchPerms;

  return (
    <AuthContext.Provider value={{ user, perms, login, logout, loading, refreshPerms }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
